module.exports = __webpack_public_path__ + "videos/mysam-identite.ca1a8a6.webm";